module.exports = __webpack_public_path__ + "static/media/empty_data_icon.90ac0f81.png";